<template>
  <div class="status-box" :class="{extrastatus: statusStats.iconCode}" :style="{borderColor: statusStats.colorCode}">
      <div :style="{backgroundColor: statusStats.colorCode}">
        <h2 v-if="statusStats.iconCode">
          <i :class="`mdi ${statusStats.iconCode}`" ></i>
        </h2>
        <h1 :style="{color: statusStats.colorCode}">{{ statusStats.orders.length }}</h1>
        <h4>{{ statusStats.title }}</h4>
      </div>
  </div>
</template>

<script>
  export default {
     props: {
       statusStats: {
         type: Object,
         default: () => ({})
       }
     }
  }
</script>

<style lang="scss" scoped>
  .status-box{
     padding: 5px;
     border: 1px solid rgb(94, 94, 94);
     border-radius: 5px;
     height: 100%;
     &.extrastatus{
       border-style: dashed;
     }
     div{
        background-color: rgb(94, 94, 94);
        color: #fff;
        text-align: center;
        padding: 25px 20px;
        border-radius: 5px;
        height: 100%;
        
     }
  }
  h1{
    font-size: 32px;
    display: inline-block;
    background-color: #fff;
    border-radius: 5px;
    padding: 5px 15px;
    margin-bottom: 20px;
  }

</style>